import { connect } from 'react-redux'

// Actions
import { doHidePopup } from 'Store/actions/popup'
import { doGetDisputeShopList, doSetShopSelectionMode } from 'Store/actions/shopPicker'

// Component
import DisputeUciTimeoutModal from './DisputeUciTimeoutModal'

const mapDispatchToProps = (dispatch) => ({
  doHidePopup: () => dispatch(doHidePopup()),
  doSetShopSelectionMode: (mode, page) => dispatch(doSetShopSelectionMode(mode, page)),
  doGetDisputeShopList: payload => dispatch(doGetDisputeShopList(payload))
})

const mapStateToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(DisputeUciTimeoutModal)
